import { RowList } from '@/components/ui/row-list';
import { SettingsHubCard } from '@/components/ui/settings-hub-card';
import { useLanguage } from '@/i18n/language-hooks';
import { Network, Users } from 'lucide-react';

export function SuccessionSettingsLinks() {
  const { t } = useLanguage();

  return (
    <RowList aria-label={t('planning.succession.settingsLinks')}>
      <SettingsHubCard
        href='/settings/parties'
        icon={Users}
        title={t('settingsHub.parties.title')}
        description={t('settingsHub.parties.description')}
      />
      <SettingsHubCard
        href='/settings/ownership-structure'
        icon={Network}
        title={t('settingsHub.estateStructure.title')}
        description={t('settingsHub.estateStructure.description')}
      />
    </RowList>
  );
}
